import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { setExportOption } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/export-option/export-option.actions';
import { decrementCurrentWizardStep, incrementCurrentWizardStep, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@angular/common";
import * as i3 from "@angular/forms";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = a0 => ({ disabled: a0 });
function ExportOptionsModalComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "label", 16)(2, "input", 17);
    i0.ɵɵtwoWayListener("ngModelChange", function ExportOptionsModalComponent_div_10_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r2.selectedExportOption, $event) || (ctx_r2.selectedExportOption = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("change", function ExportOptionsModalComponent_div_10_Template_input_change_2_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onOptionChange()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 18);
    i0.ɵɵelementStart(4, "span", 19);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵtext(6, "\u00A0 ");
    i0.ɵɵelementStart(7, "span", 20);
    i0.ɵɵlistener("click", function ExportOptionsModalComponent_div_10_Template_span_click_7_listener() { const option_r4 = i0.ɵɵrestoreView(_r2).$implicit; i0.ɵɵnextContext(); const help_r5 = i0.ɵɵreference(21); return i0.ɵɵresetView(help_r5.openModal(option_r4.help_modal_name)); });
    i0.ɵɵtext(8, "(?)");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const option_r4 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", option_r4.value);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.selectedExportOption);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(option_r4.label);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("tooltipTitle", "Help")("tooltipPlacement", "top");
} }
/**
 * Export Options Modal Component
 *
 * This component displays the different options for exporting a Single Tearsheet report for a Security List.
 * We add/remove this wizard step from inside the ReportSecuritySearchModalComponent if the conditions apply
 * since we need to wait until the users' security selection.
 *
 * Output Properties:
 *  broadcastWizardStepEvent: emits when moving to the next wizard step in the report generation process.
 *
 */
export class ExportOptionsModalComponent {
    constructor(store) {
        this.store = store;
        this.broadcastWizardStepEvent = new EventEmitter();
        this.isOpen = false;
        this.exportOptions = [
            {
                value: 'single_pdf',
                label: 'Single File',
                help_modal_name: 'single_file_export_type',
            },
            {
                value: 'zip',
                label: 'Separate Files',
                help_modal_name: 'separate_files_export_type',
            },
            {
                value: 'both',
                label: 'Both',
                help_modal_name: 'both_export_types',
            },
        ];
        this.selectedExportOption = null;
        this.mapStateToComponent = (state) => {
            this.selectedExportOption = state.exportOption;
        };
        this.storeSubscription = this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        if (this.storeSubscription) {
            this.storeSubscription.unsubscribe();
        }
    }
    closeModal() {
        this.isOpen = false;
    }
    openModal() {
        this.isOpen = true;
    }
    onOptionChange() {
        this.store.dispatch(setExportOption({ exportOption: this.selectedExportOption }));
    }
    back() {
        this.store.dispatch(decrementCurrentWizardStep());
        this.closeModal();
        this.broadcastWizardStepEvent.emit();
    }
    forward() {
        this.store.dispatch(incrementCurrentWizardStep());
        this.closeModal();
        this.broadcastWizardStepEvent.emit();
    }
    exitModalHandler() {
        this.store.dispatch(resetAllCustomPdfReportItems());
        this.closeModal();
    }
}
ExportOptionsModalComponent.ɵfac = function ExportOptionsModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ExportOptionsModalComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
ExportOptionsModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExportOptionsModalComponent, selectors: [["ycn-export-options-modal"]], outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, decls: 22, vars: 6, consts: [["help", ""], [3, "closeModalHandler", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], [1, "mb-row"], [1, "mb-20", "form-inline", "align-items-baseline"], [1, "form-label", "form-label-thin"], ["class", "mr-2", 4, "ngFor", "ngForOf"], [1, "divider-horizontal"], [1, "modal-footer"], [1, "modal-footer-actions"], [1, "btn", "btn-text", 3, "click"], [1, "btn", "btn-secondary", 3, "click"], [1, "btn", "btn-primary", 3, "click", "ngClass"], [1, "mr-2"], [1, "custom-control", "custom-radio", "mr-0"], ["type", "radio", "name", "exportOption", 1, "custom-control-input", 3, "ngModelChange", "change", "value", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description"], ["ycnTooltip", "", 1, "help-toggler", 3, "click", "tooltipTitle", "tooltipPlacement"]], template: function ExportOptionsModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function ExportOptionsModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 2);
        i0.ɵɵlistener("closeModalHandler", function ExportOptionsModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div")(3, "div", 3)(4, "div", 4)(5, "div", 5);
        i0.ɵɵtext(6, " Select how you would like the tearsheets to be grouped. ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 6)(8, "div", 7);
        i0.ɵɵtext(9, "Export as:");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, ExportOptionsModalComponent_div_10_Template, 9, 5, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(11, "div", 9);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(12, "div", 10)(13, "div", 11)(14, "div", 12);
        i0.ɵɵlistener("click", function ExportOptionsModalComponent_Template_div_click_14_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵtext(15, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 13);
        i0.ɵɵlistener("click", function ExportOptionsModalComponent_Template_div_click_16_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.back()); });
        i0.ɵɵtext(17, "Back");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 14);
        i0.ɵɵlistener("click", function ExportOptionsModalComponent_Template_div_click_18_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.forward()); });
        i0.ɵɵtext(19, " Next ");
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelement(20, "ycn-help-modal", null, 0);
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.isOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Generate Report");
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngForOf", ctx.exportOptions);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, !ctx.selectedExportOption));
    } }, dependencies: [i2.NgClass, i2.NgForOf, i3.DefaultValueAccessor, i3.RadioControlValueAccessor, i3.NgControlStatus, i3.NgModel, i4.HelpModalComponent, i5.ModalBaseComponent, i6.SimpleModalHeaderComponent, i7.TooltipDirective], encapsulation: 2 });
